import { TableColumn } from 'modules/shared-components/data-display/table/types';
import { Pagination } from 'api/types/httpsTypes';
import Big from 'big.js';

export interface Position {
  id: string;
  key: number;
  fraction: string;
  hits: number;
}

export type ColumnProps = {
  pagination: Pagination;
  data: Position[];
  errors?: any[];
};

export const riskColumn: TableColumn<ColumnProps['data'][number]>[] = [
  {
    label: 'MILESTONE',
    key: 'milestone',
    component: ({ data }) => (
      <span>
        {data.key === 0 ? (
          'Base Order'
        ) : !data.key ? (
          <span>Others</span>
        ) : (
          <span>Safety Order {data.key}</span>
        )}
      </span>
    ),
  },
  {
    label: 'HITS',
    key: 'hits',
    component: ({ data }) => <span>{data.hits}</span>,
  },
  {
    label: 'HIT RATIO',
    key: 'openTime',
    component: ({ data }) => (
      <span>{Big(data.fraction).times(100)?.toFixed(1)}%</span>
    ),
  },
];
